import { Injectable } from '@angular/core';
import * as Parse from 'parse';
import {PARSE_APP_ID, PARSE_MASTER_KEY, PARSE_SERVER_URL, production} from "../util/constants";


@Injectable()
export class PageService {

  parseAppId = PARSE_APP_ID;
  serverURL = PARSE_SERVER_URL;
  masterKey = PARSE_MASTER_KEY;

  constructor() { }

  init() {
    if (!production) {
      Parse.CoreManager.set('REQUEST_HEADERS', {'x-parse-application-id': this.parseAppId});
      Parse.CoreManager.set('REQUEST_HEADERS', {'x-parse-master-key': this.masterKey});
    }
    Parse.initialize(this.parseAppId, this.masterKey);
    Parse.serverURL = this.serverURL;
  }

  async get(tipoPagina: string) {
    this.init();
    const Pagina = Parse.Object.extend(tipoPagina);
    const queryPagina = new Parse.Query(Pagina);
    queryPagina.include('titulo');
    queryPagina.include('subtitulo');
    const results = await queryPagina.find();
    const arrayFinal: Array<any> = [];
    if (results.length > 0) {
      for (let i = 0; i < results.length; i ++) {
        const pagina = JSON.parse(JSON.stringify(results[i]));
        const queryTitulo = results[i].get('titulo').query();
        const titulo = await queryTitulo.find();
        const querySubtitulo = results[i].get('subtitulo').query();
        const subtitulo = await querySubtitulo.find();
        pagina.titulo = JSON.parse(JSON.stringify(titulo[0]));
        pagina.subtitulo = JSON.parse(JSON.stringify(subtitulo[0]));
        arrayFinal.push(pagina);
      }
    }
    return JSON.parse(JSON.stringify(arrayFinal))[0];
  }

}



// WEBPACK FOOTER //
// ./src/app/services/page.service.ts